import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Account } from '../../../../models/ui/account.model';

@Component({
    selector: 'lex-export-accounts-dialog',
    templateUrl: './export-accounts-dialog.component.html',
    styleUrls: ['./export-accounts-dialog.component.scss'],
    standalone: false
})
export class ExportAccountsDialogComponent {

	public selectedAccount: Account = null;
	public exportAccountForm: UntypedFormGroup;

	constructor(private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<ExportAccountsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private inputAccount: Account) {
		this.selectedAccount = inputAccount;
		this.exportAccountForm = this.formBuilder.group({
			exportAll: ['all', [Validators.required]]
		});
	}

	public export(): void {
		this.dialogRef.close(this.exportAccountForm.controls['exportAll'].value);
	}

}
